import { render } from "./LectureList.vue?vue&type=template&id=46b9b65c"
import script from "./LectureList.vue?vue&type=script&lang=js"
export * from "./LectureList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__